import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges, ViewChildren, QueryList } from '@angular/core';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import { ModalViewVideComponent } from 'app/shared/modal-view-video/modal-view-video.component';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { TransportsService } from '../transports.service';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'usb-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrls: ['./vehicle.component.scss']
})
export class VehicleComponent implements OnInit, OnChanges {

  @ViewChild('politicsAccordion') politicsAccordion: any;
  @ViewChild('politicsSection') politicsSection!: ElementRef;

  @ViewChildren('languageSelect') languageSelects!: QueryList<ElementRef<HTMLSelectElement>>;

  @Input() vehicles: any;
  @Input() index: number;
  @Input() selected: any[];
  @Input() tabActive?: any;
  @Input() payloadUpdate: any;
  @Input() result: any;
  @Input() infoTransfer: any;
  @Input() fliyingInfo: any;
  @Input() formTransport: any;
  @Input() payload: any;
  @Input() clientSetting: any;
  @Input() currencies: any[] = [];
  @Input() currencyAgency: any;
  @Input() noModalSelectedOneVehicleDoubleWay = false;
  @Input() paymentAgencyActive: any;
  @Input() data: any;
  @Input() arrayResults: any;
  @Input() quote = true;
  @Input() action = '';
  @Output() selectVehicleContinue = new EventEmitter();
  @Output() selectOneVehicleDoubleWay = new EventEmitter<boolean>(false);
  @Output() closeModalComents = new EventEmitter();

  tab = '';
  productSelect = false;
  totalQty = 0;
  currencySelected = '';
  product: any;
  selectedVehicleIndex: number | null = null;
  selectedAmenitiesVehiclesIndex: any[] = [];
  numberOfSeats = '';
  numberOfDoors = '';
  maxPax = '';
  numberLargeSuitcases = '';
  numberMediumSuitcases = '';
  numberHandBag = '';
  bsModalRef?: BsModalRef;
  detailPriceTwoWay = false;
  backgroundSelect: any;
  buttonColorActive: any;
  buttonTextActive: any;
  rate = 0;
  roundTripTime = 0;
  originalVehicles: any[] = [];
  fontSizeAdjustments = { 9: -1, 12: -6 };
  continueValidProcess = true;
  additionalPadding = 0;
  basePadding = 130;

  suggestionProduct = false;

  constructor(
              private modalService: BsModalService,
              private userService: UserService,
              private dialog: MatDialog,
              public transportService: TransportsService) { }


  ngOnChanges(changes: SimpleChanges): void {
    this.userService.numberNoCloneOneWay = this.userService.numberNoCloneOneWay;

 setTimeout(() => {
    this.vehicles?.forEach(vehicle => {
      vehicle.amenitiesIncluded?.forEach((amenity: any) => {
        if (amenity.name === 'Cargo de Acepta conductor con Idioma') {
          this.syncLanguageControl(vehicle, amenity);
        }
      });
    });
  });
  }

  ngOnInit() {
    if(this.arrayResults && this.arrayResults.length > 0 && this.arrayResults[0].component) {
      if(this.arrayResults[0].component === 'suggestion_itinerary') {
        this.suggestionProduct = true;
      }
    }

    if(this.quote) {
         this.originalVehicles = JSON.parse(JSON.stringify(this.vehicles));

    } else {
       this.productSelect = true;
       this.productVehicleSelect(0, this.product, 'false');
      //  this.product = this.vehicles[0];
    }

    this.continueValidProcess = true;

    if(this.tabActive){
      this.onTabSelect(this.tabActive);
    }else{
      this.onTabSelect('includes');
    }

    this.createdAmenitiesIncluded();
    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body).card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    this.validateEntryAndReturnTime();

  }

  /**
   * Método para manejar la selección de pestañas en la interfaz
   *
   * Si la pestaña seleccionada es 'includes', reinicia la selección.
   * Si la pestaña es 'photos', dispara un evento resize para ajustar el contenido.
   *
   * @param tabName -> nombre de la pestaña seleccionada
   */
  onTabSelect(tabName: string): void {
    if (tabName === 'product') {
      this.resetSelection();
    }
    if (tabName === 'photos') {
      setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
    }
    this.tab = tabName;
  }

  /**
   * Método para inicializar las amenidades incluidas en cada vehículo
   *
   * Recorre la lista de vehículos y resetea la propiedad amenitiesIncluded,
   * además actualiza el precio neto con inclusión de amenidades para cada vehículo.
   */
  createdAmenitiesIncluded(): void {
    // quote=false significa que este componente se está reutilizando para ver el
    // detalle de un producto YA agregado al itinerario (vehicles[0] es el mismo
    // objeto que itinerary.items[i], no una copia). Resetear acá borraría los
    // amenitiesIncluded que el usuario ya eligió al reservar.
    if (!this.quote) {
      return;
    }
    this.vehicles = this.vehicles.map((vehicle: any) => {
      vehicle.amenitiesIncluded = [];
      if(!this.payload.transfers?.oneWay) {
        if(vehicle.amenities && vehicle.amenities.length > 0) {
          vehicle.amenities.forEach((amenity: any) => {
            if(!amenity.included) {
              amenity.price = amenity.price;
            }
          });
        }
      } else {

      }
      vehicle.netPriceBookingWithIncluded = vehicle.profility.netPriceBooking;
      return vehicle;
    });
  }

  /**
   * Método que se ejecuta cuando un producto (vehículo) es seleccionado
   *
   * - Si el traslado no es one-way y el usuario no ha seleccionado vehículo para vuelta,
   *   muestra un modal para confirmar si quiere elegir el mismo vehículo para el regreso.
   * - Según la respuesta del modal, emite evento para seleccionar vehículo de ida y vuelta,
   *   o solo el de ida.
   * - En caso contrario, selecciona el vehículo normalmente.
   *
   * @param index -> índice del vehículo seleccionado en la lista
   * @param vehicle -> objeto del vehículo seleccionado
   */
  productSelected(index: number, vehicle: any): void {

    if (!this.canSelectVehicle(vehicle)) {
      console.error('No se puede seleccionar este vehículo');
      return;
    }

    if(!this.payload.transfers.oneWay && this.userService.numberNoCloneOneWay === 0) {

      const extraMessage =
      vehicle.netPriceBookingWithIncluded > vehicle?.netPriceProf
        ? `Más ${this.currencyAgency?.code} ${(((vehicle.netPriceBookingWithIncluded - vehicle?.netPriceProf) / 2) * this.currencyAgency?.rate).toFixed(2)} adicionales.`
        : '';

      const message = `¿Quieres elegir este mismo <br /> vehículo para la vuelta? <br /> <br /> en caso de no hacerlo <br /> el precio del viaje será de <b> ${this.currencyAgency?.code} ${(vehicle?.profilityEntry?.netPriceBooking * this.currencyAgency?.rate).toFixed(2)}. ${extraMessage} </b>`;

      const initialState: ModalOptions = {
        initialState: {
          message,
        }
      };

           this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
           const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
             if(result) {
               this.detailPriceTwoWay = true;
               this.selectOneVehicleDoubleWay.emit(true);
               this.productVehicleSelect(index, null, 'true');
              } else {
                 this.selectOneVehicleDoubleWay.emit(false);
                 this.productVehicleSelect(index, null, 'false');


                 this.bsModalRef.hide();
             }
             confirmSubscription.unsubscribe();
           });
    } else {
      this.productVehicleSelect(index, null, 'null');
    }
  }

  canSelectVehicle(vehicle: any): boolean {
    return this.transportService.canAssignVehicle(vehicle, this.suggestionProduct);
  }

/**
 * Método para seleccionar un vehículo en la lista
 *
 * - Si el vehículo seleccionado es el mismo que el actual, se deselecciona.
 * - Si es diferente, actualiza la selección, asigna los precios y detalles del vehículo,
 *   y resetea algunas fechas relacionadas al traslado.
 * - Maneja condiciones específicas para el doble uso del vehículo en viajes ida y vuelta
 *   ajustando los precios según corresponda.
 *
 * @param index -> índice del vehículo seleccionado
 * @param vehicle -> objeto vehículo opcional con detalles para actualizar la selección
 * @param noCloneVehicleDoubleWay -> cadena que indica si se selecciona vehículo para doble viaje ('true' o 'false')
 */
  productVehicleSelect(index: number, vehicle?: any, noCloneVehicleDoubleWay?: string): void {

    if(this.selectedVehicleIndex === index) {

      this.selectedVehicleIndex = null;
      this.productSelect = false;
      this.product = {};
      this.totalQty = 0;
      this.tab = 'includes';

    } else {
      const product = this.vehicles[index];
      if(product) {
        if(vehicle) {
          product.profility = vehicle.profilityEntry;
          product.netPriceBookingWithIncluded = vehicle.profility.netPriceBooking;
          product.netPriceFreeTax = vehicle.profility.netPrice;
          product.netPriceProf = vehicle.profility.netPriceBooking;
          product.netPriceUnitary = vehicle.profility.netPrice;
          product.totalPriceFreeTax = vehicle.profility.netPrice;
          product.totalPriceProf = vehicle.profility.netPriceBooking;
          this.infoTransfer.secondArrivalDate = null;
          this.infoTransfer.secondtTime = null;
          this.formTransport.secondArrivalDate = null;
          this.formTransport.secondTime = null;

        }
        if(noCloneVehicleDoubleWay === 'false') {

                product.profility= product?.profilityEntry;
                product.netPriceProf= product?.profilityEntry?.netPriceBooking;
                product.cancellationPolicies = product?.timing?.entry?.entryCancellationPolicies;
                product.netPriceFreeTax= product?.profilityEntry?.netPrice;
                product.netPriceUnitary= product?.profilityEntry?.netPrice;
                product.totalPriceFreeTax= product?.profilityEntry?.netPriceBooking;
                product.totalPriceProf= product?.profilityEntry?.netPriceBooking;
                product.netPriceBookingWithIncluded = product.netPriceBookingWithIncluded > product?.profilityEntry?.netPriceBooking ? product.netPriceBookingWithIncluded / 2: product?.profilityEntry?.netPriceBooking;

        } else if(noCloneVehicleDoubleWay === 'true') {
          product.netPriceBookingWithIncluded = product.netPriceBookingWithIncluded > product?.profilityEntry?.netPriceBooking ? product.netPriceBookingWithIncluded : product?.netPriceBooking;
        }

        this.selectedVehicleIndex = index;
        this.totalQty = product.netPriceBookingWithIncluded && product.netPriceBookingWithIncluded > product.profility?.netPriceBooking ? product.netPriceBookingWithIncluded : product.profility?.netPriceBooking;
        this.productSelect = true;
        this.product = product;
        this.getNumberOfSeats(product.vehicle.number_of_seats);
        this.getNumberOfDoors(product.vehicle.number_of_doors);
        this.getMaxPax(product.vehicle.maxPax);
        this.getNumberLargeSuitcases(product.vehicle.bag.numberLargeSuitcases);
        this.getNumberMediumSuitcases(product.vehicle.bag.numberMediumSuitcases);
        this.getHandBags(product.vehicle.bag.numberHandbags);
        this.currencySelected = product.pricing?.currency;
        this.onTabSelect('info');
      }

    }
  }

  /**
   * Método para reiniciar la selección de vehículos y amenidades
   *
   * - Limpia el índice de vehículos y amenidades seleccionadas.
   * - Resetea las variables relacionadas a la selección y detalle de precios.
   * - Restablece las amenidades y precios incluidos para cada vehículo a sus valores iniciales.
   */
  resetSelection(): void {
    this.selectedAmenitiesVehiclesIndex = [];
    this.detailPriceTwoWay = false;
    this.productSelect = false;
    this.product = {};
    this.totalQty = 0;

    this.resetModifiedVehicle();
    this.selectedVehicleIndex = null;
    this.userService.numberNoCloneOneWay = 0;

    this.vehicles.forEach(vehicle => {
      vehicle.amenitiesIncluded = [];
      vehicle.netPriceBookingWithIncluded = vehicle.profility?.netPriceBooking || 0;
    });
  }

  /**
   * Resetea los vehículos que fueron modificados durante la selección
   */
resetModifiedVehicle(): void {
 this.vehicles.forEach((vehicle, index) => {
    const originalVehicle = this.originalVehicles[index];
    if (originalVehicle) {
      // Restaurar propiedades modificadas
      vehicle.profility = { ...originalVehicle.profility };
      vehicle.netPriceBookingWithIncluded = originalVehicle.netPriceBookingWithIncluded;
      vehicle.netPriceFreeTax = originalVehicle.netPriceFreeTax;
      vehicle.netPriceProf = originalVehicle.netPriceProf;
      vehicle.netPriceUnitary = originalVehicle.netPriceUnitary;
      vehicle.totalPriceFreeTax = originalVehicle.totalPriceFreeTax;
      vehicle.totalPriceProf = originalVehicle.totalPriceProf;
      vehicle.amenitiesIncluded = [...(originalVehicle.amenitiesIncluded || [])];
    }
  });
}

  /**
   * Método para asignar el número de asientos del vehículo
   *
   * @param numberOfSeats -> número de asientos recibido
   * Se asigna el valor recibido si no está vacío, caso contrario se asigna 'N/A'
   */
  getNumberOfSeats(numberOfSeats: any): void {
    this.numberOfSeats = numberOfSeats !== '' ? numberOfSeats : 'N/A';
  }

  /**
   * Método para asignar el número de puertas del vehículo
   *
   * @param numberOfDoors -> número de puertas recibido
   * Se asigna el valor recibido si no está vacío, caso contrario se asigna 'N/A'
   */
  getNumberOfDoors(numberOfDoors: any): void {
    this.numberOfDoors = numberOfDoors !== '' ? numberOfDoors : 'N/A';
  }

  /**
   * Método para asignar la capacidad máxima de pasajeros del vehículo
   *
   * @param maxPax -> cantidad máxima de pasajeros recibida
   * Se asigna el valor recibido si no está vacío, caso contrario se asigna 'N/A'
   */
  getMaxPax(maxPax: any): void {
    this.maxPax = maxPax !== '' ? maxPax : 'N/A';
  }

  /**
   * Método para asignar el número de maletas grandes permitidas
   *
   * @param numberlargeSuitcases -> número de maletas grandes recibido
   * Se asigna el valor recibido si no está vacío, caso contrario se asigna 'N/A'
   */
  getNumberLargeSuitcases(numberlargeSuitcases: any): void {
    this.numberLargeSuitcases = numberlargeSuitcases !== '' ? numberlargeSuitcases : 'N/A';
  }


/**
 * Método para asignar el número de maletas medianas permitidas
 *
 * @param numberMediumSuitcases -> número de maletas medianas recibidas
 * Se asigna el valor recibido si no está vacío, caso contrario se asigna 'N/A'
 */
  getNumberMediumSuitcases(numberMediumSuitcases: any): void {
    this.numberMediumSuitcases = numberMediumSuitcases !== '' ? numberMediumSuitcases : 'N/A';
  }

  /**
   * Método para asignar el número de bolsos de mano permitidos
   *
   * @param handBags -> número de bolsos de mano recibidos
   * Se asigna el valor recibido si no está vacío, caso contrario se asigna 'N/A'
   */
  getHandBags(handBags: any): void {
    this.numberHandBag = handBags !== '' ? handBags : 'N/A';
  }

  /**
   * Método para alternar la selección de una amenidad en un vehículo
   *
   * @param vehicle -> vehículo en la lista
   * @param amenity -> amenidad dentro del vehículo
   * @param amenityPrice -> precio de la amenidad para actualizar el precio total
   *
   * Si la amenidad está seleccionada, se quita y se descuenta el precio,
   * si no está seleccionada, se agrega y se suma el precio.
   */

// toggleAmenity(vehicle: any, amenity: any, amenityPrice: number): void {
//   if (!vehicle.amenitiesIncluded) vehicle.amenitiesIncluded = [];

//   const index = vehicle.amenitiesIncluded.findIndex(a => a.name === amenity.name);

//   if (index >= 0) {
//     // Remover
//     vehicle.amenitiesIncluded.splice(index, 1);
//     vehicle.netPriceBookingWithIncluded -= amenityPrice;
//   } else {
//     // Agregar
//     vehicle.amenitiesIncluded.push(amenity);
//     vehicle.netPriceBookingWithIncluded += amenityPrice;
//   }
// }

// isAmenitySelected(vehicle: any, amenity: any): boolean {
//   return vehicle.amenitiesIncluded?.some(a => a.name === amenity.name) ?? false;
// }

  /**
   *
   * @param vehicle Se le pasa el vehiculo seleccionado.
   */
  continue(vehicle: any): void{
    if(vehicle && this.continueValidProcess){
      this.continueValidProcess = false;
      this.selectVehicleContinue.emit(vehicle);
    }
  }

  /**
   * Verifica si la información del vehículo cumple una condición numérica
   *
   * @param vehicleInfo -> valor numérico o convertible a número para validar
   * @returns boolean -> true si el número es mayor que 0, false en caso contrario
   */
  verifyConditionInfo(vehicleInfo: any): boolean {
    return Number(vehicleInfo) > 0;
  }

  /**
   * Abre o cierra el acordeón de políticas y hace scroll suave a la sección cuando se abre
   */
  openPolitics(): void {
    if (this.politicsAccordion) {
      this.politicsAccordion.toggleOpen();

      // Solo hacé scroll si lo estás abriendo
      if (!this.politicsAccordion.isOpen) {
        setTimeout(() => {
          if (this.politicsSection?.nativeElement) {
            this.politicsSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 200);
      }
    }
  }

  /**
   * Extrae el nombre del transporte según el tipo y el formulario recibido
   *
   * @param form -> objeto con datos del transporte
   * @param type -> cadena que indica si es 'origin' o 'destination'
   * @returns string -> nombre del transporte formateado según tipo y datos
   */
  extractNameTransport(form: any, type: string): string {

    switch(type) {
      case 'origin':
        switch(this.payload.transfers.pickupLocation.type) {
          case 'hotel':
            return form.name;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'destination':
            return form.city_name;
        }
      case 'destination':
        switch(this.payload.transfers.dropoffLocation.type) {
          case 'hotel':
            return form.name;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'destination':
            return form.city_name;
        }
    }

  }

  /**
   * Extrae la dirección o tipo formateado según el transporte y tipo
   *
   * @param form -> objeto con datos del transporte
   * @param type -> cadena que indica si es 'origin' o 'destination'
   * @returns string -> dirección formateada o cadena vacía según condiciones
   */
  extractAddressType(form: any, type: string): string {
    switch(type) {
      case 'origin':
        switch(this.payload.transfers.pickupLocation.type) {
          case 'hotel':
            return `
            clgm.address}`;
          case 'airport':
            return '';
          case 'destination':
            return '';
        }
      case 'destination':
        switch(this.payload.transfers.dropoffLocation.type) {
          case 'hotel':
            return `- ${form.address}`;
          case 'airport':
            return '';
          case 'destination':
            return '';
        }
    }
  }

  /**
   *
   * @param vehicle Indicamos el vehiculo que se esta renderizando actualmente.
   * @returns Retorna un boolean para visualizar el N/A
   */
  validateNotIncludedAmenities(vehicle: any): boolean{
    let validateNotIncluded;
    const lengthNotIncluded = vehicle.amenities.filter((amenitie: any) => !amenitie.included);

    if(lengthNotIncluded.length == 0){
      validateNotIncluded = true;
    }

    return validateNotIncluded;
  }

  validateIncludedAmenities(vehicle: any): boolean{
    let validateNotIncluded = false;
    const lengthNotIncluded = vehicle.amenities.filter((amenitie: any) => amenitie.included);

    if(lengthNotIncluded.length == 0){
      validateNotIncluded = true;
    }
    return validateNotIncluded;
  }


  validateEntryAndReturnTime(): void{
  const entryTime = this.vehicles[0].timing.entry.entryTravelTime;
  const returnTime = this.vehicles[0].timing.return.returnTravelTime;

  if(entryTime && !returnTime){
    this.roundTripTime = Number(entryTime);
  }else{
    this.roundTripTime = Number(entryTime) + Number(returnTime);
  }
}


getCommentadjective(adjetive: number): string {

          switch(adjetive) {
            case 0: return 'SIN CALIFICAR';
            case 1: return 'Mala';
            case 2: return 'Regular';
            case 3: return 'Buena';
            case 4: return 'Muy buena';
            case 5: return 'Excelente';
          }
        }

validPaymentConditionAgencyAvailable(rateClass: any): boolean {

    const result = rateClass === 'NR'
      ? this.paymentAgencyActive.non_refundable === 0 ? false : true
      : true;

    return result;
  }

    /**
     * Método para abrir el modal con el video de YouTube
     *
     * Este método obtiene el ID del video de YouTube desde una URL,
     * y abre un modal personalizado para visualizarlo.
     *
     * @data -> contiene la URL del video a mostrar
     */

  openVideoModal(data: any) {

    if(!data) {
      return;
    };

    const idVideo = this.getIdVideoYt(data);

    const dialogRef = this.dialog.open(ModalViewVideComponent, {
      width: '700px',
      data: idVideo,
    });
    dialogRef.afterClosed().subscribe((result) => {
      // Puede manejar el resultado aquí si es necesario
    });
  }


    /**
     * Método para obtener el ID del video de YouTube
     *
     * A partir de una URL de YouTube, extrae el identificador único del video.
     * Soporta varios formatos de enlace de YouTube.
     *
     * @url -> string con la URL del video de YouTube
     * @return -> string con el ID del video, o null si no es válido
     */

  getIdVideoYt(url: any) {
    if (url) {
      const getIdVideo = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/;
      const match = url.match(getIdVideo);
      return match ? match[1] : null;
    } else {
      return null;
    }
  }

  validateTransferName(transferName: any): boolean {
    if(typeof transferName === 'string' || transferName == ''){
      return false;
    }
  }


languageControls: { [key: string]: FormControl } = {};
quantityControls: { [key: string]: FormControl } = {};
pendingAmenities: { [key: string]: boolean } = {};

getQuantityControl(vehicle: any, amenity: any): FormControl {
  const key = `${vehicle.id}_${amenity.name}`;

  if (!this.quantityControls[key]) {
    const initialValue = this.getAmenityQuantity(vehicle, amenity);
    const isDisabled = !this.isQuantitySelectable(vehicle, amenity);

    this.quantityControls[key] = new FormControl({
      value: initialValue,
      disabled: isDisabled
    });

    this.quantityControls[key].valueChanges.subscribe(value => {
      // ✅ Solo cuando se selecciona una cantidad, se guarda el extra
      this.updateAmenityQuantity(vehicle, amenity, value);
    });
  }

  return this.quantityControls[key];
}


// ==================== FUNCIONES AUXILIARES ====================

/**
 * Calcular la cantidad PAGADA (excluyendo las gratuitas del minimumQuantity)
 */
calculatePaidQuantity(totalQuantity: number, minFree: number): number {
  if (totalQuantity <= minFree) {
    return 0;
  }
  return totalQuantity - minFree;
}

/**
 * Calcular el precio total basado en la cantidad TOTAL seleccionada
 * (las primeras 'minimumQuantity' son gratis)
 */
calculateAmenityPrice(amenity: any, totalQuantity: number): number {
  if (!amenity.priceProf) {
return 0;
}

  const paidQuantity = this.calculatePaidQuantity(totalQuantity, amenity.minimumQuantity || 0);
  return paidQuantity * amenity.priceProf;
}

// ==================== ACTUALIZAR CANTIDAD (BAGGAGE) ====================

updateAmenityQuantity(vehicle: any, amenity: any, value: number): void {
  const key = `${vehicle.id}_${amenity.name}`;

  if (value > 0) {
    let amenityVehicle = vehicle.amenitiesIncluded?.find((c: any) => c.name === amenity.name);

    if (!amenityVehicle) {
      if (!vehicle.amenitiesIncluded) {
vehicle.amenitiesIncluded = [];
}
      amenityVehicle = {
        name: amenity.name,
        optionSelected: value,
        price: amenity.price,                                                    // Total seleccionado (ej: 4)
        paidQuantity: this.calculatePaidQuantity(value, amenity.minimumQuantity || 0), // Cantidad que se cobra (ej: 2)
        totalPrice: this.calculateAmenityPrice(amenity, value),              // Precio total (ej: 2 * price)
        pricePerUnit: amenity.priceProf,
        minimumQuantity: amenity.minimumQuantity,
        maximumQuantity: amenity.maximumQuantity,
        paymentOffice: amenity?.paymentOffice ? true : false,
        included: false,
        description: amenity.description,
        type: amenity.type,
        id: amenity.id
      };
      vehicle.amenitiesIncluded.push(amenityVehicle);
    } else {
      amenityVehicle.quantity = value;
      amenityVehicle.paidQuantity = this.calculatePaidQuantity(value, amenity.minimumQuantity || 0);
      amenityVehicle.totalPrice = this.calculateAmenityPrice(amenity, value);
    }

    delete this.pendingAmenities[key];
    this.recalculateVehiclePrice(vehicle);
  } else {
    // Si cantidad es 0, eliminar el amenity
    const index = vehicle.amenitiesIncluded?.findIndex((c: any) => c.name === amenity.name);
    if (index !== undefined && index >= 0) {
      vehicle.amenitiesIncluded.splice(index, 1);
      this.recalculateVehiclePrice(vehicle);
    }
  }

}

// ==================== RECALCULAR PRECIO TOTAL ====================

recalculateVehiclePrice(vehicle: any): void {

  const basePrice = vehicle?.profility?.netPriceBooking || vehicle?.netPriceBooking || 0;

  if (!vehicle.amenitiesIncluded || vehicle.amenitiesIncluded.length === 0) {
    vehicle.netPriceBookingWithIncluded = basePrice;
    return;
  }

  // Sumar el total de cada amenity (usando totalPrice que ya está calculado)
  const amenitiesTotal = vehicle.amenitiesIncluded.reduce((total: number, amenity: any) => {
    // Para Baggage: usa totalPrice (ya calculado con paidQuantity)
    // Para Language: usa pricePerUnit
    const amenityPrice = amenity.totalPrice || 0;
    return total + amenityPrice;
  }, 0);

  vehicle.netPriceBookingWithIncluded = basePrice + amenitiesTotal;
}


// ==================== IDIOMA (similar a cantidad) ====================

getLanguageControl(vehicle: any, amenity: any): FormControl {
  const key = `${vehicle.id}_${amenity.name}`;

  if (!this.languageControls[key]) {
    const initialValue = this.getAmenityLanguage(vehicle, amenity);
    const isDisabled = !this.vehicleAcceptLangagues(vehicle);

    this.languageControls[key] = new FormControl({
      value: initialValue,
      disabled: isDisabled
    });

    this.languageControls[key].valueChanges.subscribe(value => {
      // ✅ Solo cuando se selecciona un idioma, se guarda el extra
      this.updateAmenityLanguage(vehicle, amenity, value);
    });
  }

  return this.languageControls[key];
}

updateAmenityLanguage(vehicle: any, amenity: any, value: string): void {
  const key = `${vehicle.id}_${amenity.name}`;

  if (value && value !== 'Seleccione') {
    let amenityVehicle = vehicle.amenitiesIncluded?.find((c: any) => c.name === amenity.name);

    if (!amenityVehicle) {
      if (!vehicle.amenitiesIncluded) {
vehicle.amenitiesIncluded = [];
}
      amenityVehicle = {
        name: amenity.name,
         price: amenity.price,
        optionSelected: value,
        totalPrice: amenity.priceProf,
        pricePerUnit: amenity.priceProf,
        included: false,
        description: amenity.description,
        paymentOffice: amenity?.paymentOffice ? true : false,
        type: amenity.type,
        id: amenity.id
      };
      vehicle.amenitiesIncluded.push(amenityVehicle);
    } else {
      amenityVehicle.language = value;
    }

    // Limpiar estado pendiente
    delete this.pendingAmenities[key];

    // Recalcular precio total
    this.recalculateVehiclePrice(vehicle);
  } else {
    // Si no hay idioma seleccionado, eliminar
    const index = vehicle.amenitiesIncluded?.findIndex((c: any) => c.name === amenity.name);
    if (index !== undefined && index >= 0) {
      vehicle.amenitiesIncluded.splice(index, 1);
      this.recalculateVehiclePrice(vehicle);
    }
  }
}



  // Verificar si se puede seleccionar cantidad (si está incluido o no)
isQuantitySelectable(vehicle: any, amenity: any): boolean {
  // Si ya está incluido (included = true), no se puede modificar
  // Si no está incluido, se puede agregar
  return !amenity.included;
}

// Obtener la cantidad actual del amenity (de la propiedad quantity)
getAmenityQuantity(vehicle: any, amenity: any): number {
  const amenityVehicle = vehicle.amenitiesIncluded?.find((c: any) => c.name === amenity.name);
  return amenityVehicle?.quantity || 0;
}




// Obtener las opciones de cantidad (desde min hasta max)
  getQuantityOptions(amenity: any): number[] {
  const options = [];
  const min = 1;
  const max = amenity.maximumQuantity || 10;

  for (let i = min; i <= max; i++) {
    options.push(i);
  }
  return options;
}

getQuantityPetsOptions(vehicle: any): number[] {

  const options = [];
  const min = 1;
  const max = vehicle?.vehicle?.capacities?.pets?.maximum || 10;

  for (let i = min; i <= max; i++) {
    options.push(i);
  }
  return options;
}
// Verificar si el vehicle ya tiene este amenity (para mostrar el valor actual)
hasAmenityQuantity(vehicle: any, amenity: any): boolean {
  const amenityVehicle = vehicle.amenitiesIncluded?.find((c: any) => c.name === amenity.name);
  return !!(amenityVehicle && amenityVehicle.quantity > 0);
}

// Función helper para obtener el idioma actual
public getAmenityLanguage(vehicle: any, amenity: any): string {
  const amenityVehicle = vehicle.amenitiesIncluded?.find((c: any) => c.name === amenity.name);
  return amenityVehicle?.language || '';
}


vehicleAcceptLangagues(vehicle: any): boolean {
  return !vehicle.amenitiesIncluded?.some(c => c.name === 'Cargo de Acepta conductor con Idioma');
}

vehicleAcceptAddons(vehicle: any, amenity: any): boolean {
  return !vehicle.amenitiesIncluded?.some(c => c.name === amenity.name);
}

syncLanguageControl(vehicle: any, amenity: any): void {
  const key = `${vehicle.id}_${amenity.name}`;
  const control = this.languageControls[key];

  if (control) {
    const currentValue = this.getAmenityLanguage(vehicle, amenity);
    if (control.value !== currentValue) {
      control.setValue(currentValue, { emitEvent: false });
    }
  }
}

/**
 * Calcular la cantidad PAGADA (excluyendo las gratuitas del minimumQuantity)
 */
// calculatePaidQuantity(totalQuantity: number, minFree: number): number {
//   if (totalQuantity <= minFree) {
//     return 0;
//   }
//   return totalQuantity - minFree;
// }


resetAmenityControls(vehicle: any, amenity: any): void {
  const key = `${vehicle.id}_${amenity.name}`;

  // Resetear quantity control (baggage)
  const quantityControl = this.quantityControls[key];
  if (quantityControl) {
    quantityControl.setValue(0, { emitEvent: false });
    quantityControl.disable();
  }

  // Resetear language control
  const languageControl = this.languageControls[key];
  if (languageControl) {
    languageControl.setValue('', { emitEvent: false });
    languageControl.disable();
  }
}

toggleAmenity(vehicle: any, amenity: any): void {
  const key = `${vehicle.id}_${amenity.name}`;
  const isCurrentlySelected = this.isAmenitySelected(vehicle, amenity);

  // Verificar si es un amenity simple (sin opciones de cantidad ni idioma)
  const isSimpleAmenity = this.isSimpleAmenity(amenity);

  if (isCurrentlySelected) {
    // DESMARCAR
    // Limpiar pending
    delete this.pendingAmenities[key];

    // Eliminar de amenitiesIncluded
    const index = vehicle.amenitiesIncluded?.findIndex((a: any) => a.name === amenity.name);
    if (index !== undefined && index >= 0) {
      const removed = vehicle.amenitiesIncluded.splice(index, 1)[0];
      this.recalculateVehiclePrice(vehicle);
    }

    // Resetear controles (si los tiene)
    this.resetAmenityControls(vehicle, amenity);

  } else {
    // MARCAR
    if (isSimpleAmenity) {
      // ✅ Amenity simple: agregar DIRECTAMENTE a amenitiesIncluded
      if (!vehicle.amenitiesIncluded) {
vehicle.amenitiesIncluded = [];
}

      const newAmenity = {
        name: amenity.name,
        price: amenity.price,
        totalPrice: amenity.priceProf,
        pricePerUnit: amenity.priceProf,
        included: false,
        description: amenity.description,
        paymentOffice: amenity?.paymentOffice ? true : false,
        type: amenity.type,
        id: amenity.id
      };
      vehicle.amenitiesIncluded.push(newAmenity);
      this.recalculateVehiclePrice(vehicle);

    } else {
      // Amenity complejo (Baggage o Language): solo guardar intención
      this.pendingAmenities[key] = true;

      // Habilitar controles
      const quantityControl = this.quantityControls[key];
      if (quantityControl) {
quantityControl.enable();
}

      const languageControl = this.languageControls[key];
      if (languageControl) {
languageControl.enable();
}
    }
  }
}

/**
 * Determinar si un amenity es simple (sin cantidad ni opciones de idioma)
 */
isSimpleAmenity(amenity: any): boolean {
  const complexTypes = ['Baggage', 'Language', 'PetsAllowed'];
  return !complexTypes.includes(amenity.type);
}

/**
 * Obtener el precio de un amenity simple
 */
getSimpleAmenityPrice(vehicle: any, amenity: any): number {
  const amenityVehicle = vehicle.amenitiesIncluded?.find((a: any) => a.name === amenity.name);
  return amenityVehicle?.totalPrice || amenity.priceProf || 0;
}

isAmenitySelected(vehicle: any, amenity: any): boolean {
  const key = `${vehicle.id}_${amenity.name}`;
  // Verificar si está pendiente O ya incluido
  return (this.pendingAmenities[key] ||
         vehicle.amenitiesIncluded?.some(a => a.name === amenity.name)) ?? false;
}

closeModal(): void {
  this.closeModalComents.emit();
}

imgVehicle(vehicle: any): void {
  return vehicle.images.find(c => c.is_cover === 1)?.thumbnail || '';
}




}
